module.exports = __webpack_public_path__ + "img/theme.b741abe3.webp";